"use strict";
/**
 * @license
 * Copyright 2022 SOUTHWORKS UK LTD All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/southworks/codeverter/blob/main/LICENSE
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Function = void 0;
const typescript_1 = require("typescript");
const variable_helper_1 = require("./helpers/variable-helper");
const type_mapper_1 = require("./type-mapper");
const typed_class_element_1 = require("./types/typed-class-element");
class Function extends typed_class_element_1.TypedClassElement {
    constructor() {
        super(...arguments);
        this.statements = [];
        this.content = [];
        this.static = true;
    }
    addParameter(node) {
        this.addElement("parameter", node);
    }
    getContent() {
        return this.content;
    }
    getStatements() {
        return this.statements;
    }
    /**
     * remove curly brackets and new line characters
     * @param body
     * @returns
     */
    trimBody(body) {
        var _a;
        let currentBody = body.substring(1, body.length - 1);
        let values = currentBody.split("\n");
        if (values[0].trim() == "") {
            values = values.splice(1);
        }
        if (((_a = values[values.length - 1]) === null || _a === void 0 ? void 0 : _a.trim()) == "") {
            values = values.splice(0, values.length - 1);
        }
        return values;
    }
    parse(node) {
        var _a, _b, _c;
        super.parse(node);
        const returnStatement = (_a = node.body) === null || _a === void 0 ? void 0 : _a.statements.find(s => s.kind == typescript_1.SyntaxKind.ReturnStatement);
        const needRefineType = (this.knownType == "array" && this.type == "void")
            || (!node.type && (returnStatement === null || returnStatement === void 0 ? void 0 : returnStatement.expression));
        if (needRefineType) {
            let typeResult = { knownType: "void", type: "void" };
            if (needRefineType.kind != undefined) {
                let typeAtLocation = this.getTypeChecker().getTypeAtLocation(needRefineType);
                typeResult = type_mapper_1.TypeMapper.getTypeFromType(typeAtLocation);
            }
            if (typeResult.knownType == "void") {
                typeResult = type_mapper_1.TypeMapper.getType(node, returnStatement.expression);
            }
            this.knownType = typeResult.knownType;
            this.type = typeResult.type;
        }
        this.content = this.trimBody((_c = (_b = node.body) === null || _b === void 0 ? void 0 : _b.getText(this.getSourceFile())) !== null && _c !== void 0 ? _c : "");
        if (node.body && (0, typescript_1.isBlock)(node.body)) {
            node.body.
                statements
                .forEach(s => {
                if ((0, typescript_1.isVariableStatement)(s)) {
                    (0, variable_helper_1.addVaribles)(s.declarationList, (k, n) => this.addElement(k, n));
                }
                this.statements.push(s);
            });
        }
        node.parameters.filter(p => !p.modifiers).forEach(m => {
            this.addParameter(m);
        });
    }
    get parameters() {
        return this.getValues("parameter");
    }
    get variables() {
        return this.getValues("variable");
    }
    get constants() {
        return this.getValues("constant");
    }
}
exports.Function = Function;
